<template>
    <div class="sa-list-component">
        <div class="sa-list-component-header">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("global.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <div class="sa-list-component-body">
            <div class="b-table-sticky-header">
                <b-table sticky-header ref="table" stacked="lg" :key="listKey" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table">
                    <template #cell(index)="row">
                        {{ (currentPage - 1) * perPage + row.index + 1 }}
                    </template>

                    <template v-slot:cell(codiceStruttura)="{ item }">
                        <span>{{ item.denominazioneStruttura }} ({{ item.codiceStruttura }})</span>
                    </template>
                    <template v-slot:cell(nome)="{ item }">
                        <!--   <router-link class="sa-edit-link" :to="'/rsaconfigurazionepostilettopiani/view/' + item.id"> -->
                        <span>{{ item.nome }}</span>
                        <!-- </router-link> -->
                    </template>

                    <template #cell(actions)="{ item }">
                        <b-container class="bv-example-row">
                            <b-button size="sm" variant="btn btn-outline-secondary waves-effect waves-light width-sm no-text" @click="onClickVisualizzaPiano(item)">
                                <font-awesome-icon icon="eye"> </font-awesome-icon>
                            </b-button>
                            <b-button size="sm" variant="btn btn-outline-success waves-effect waves-light width-sm no-text" @click="onUpdatePiano(item.id)">
                                <font-awesome-icon icon="edit"> </font-awesome-icon>
                            </b-button>
                            <b-button size="sm" class="mr-1 ml-1 no-text" variant="outline-primary " @click="onClickDuplicatePiano(item)" title="Duplica">
                                <font-awesome-icon icon="copy"> </font-awesome-icon>
                            </b-button>
                        </b-container>
                    </template>
                </b-table>
            </div>
            <b-modal ref="mdlDuplicaPiano" size="lg" title="Inserire Nome Nuovo Piano" @ok="onMdlDuplicaPiano()">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Struttura</label>
                        <span class="sa-data">{{ nuovoPiano.denominazioneStruttura }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Presidio</label>
                        <span class="sa-data">{{ nuovoPiano.denominazionePresidio }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Nome</label>
                        <b-form-input v-model="nuovoPiano.nome" placeholder="Nome del Piano"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Note</label>
                        <b-form-textarea v-model="nuovoPiano.note" rows="5" no-resize></b-form-textarea>
                    </b-col>
                </b-row>
            </b-modal>
        </div>
        <div class="sa-list-component-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <!--    <b-modal ref="mdlPianoEdit" size="lg" title="Modifica Dati Piano" @ok="onMdlPianoEditSave()">
            <ras-configurazione-posti-letto-piani-edit-component ref="cmpRasConfigurazionePostiLettoPianiEditComponent"></ras-configurazione-posti-letto-piani-edit-component>
            <template #modal-footer="{ ok, cancel }">
                <b-button size="sm" variant="danger" @click="cancel()">Annulla</b-button>
                <b-button size="sm" variant="success" @click="ok()">Salva</b-button>
            </template>
        </b-modal> -->
    </div>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
//import RasConfigurazionePostiLettoPianiEditComponent from "./RasConfigurazionePostiLettoPianiEditComponent.vue";
export default {
    components: {
        /*  RasConfigurazionePostiLettoPianiEditComponent */
    },
    mixins: [UtilityMixin],
    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            pathResource: "/rsapostilettopiani",
            nuovoPiano: {},
            filtroConfigurazionePostiLetto: { denominazioneStruttura: null, denominazionePresidio: null, nome: null },
            items: [],
            id: "",
            listKey: 0,
            fields: [
                {
                    label: "*",
                    key: "index",
                },
                {
                    label: "Struttura",
                    key: "codiceStruttura",
                    sortable: true,
                    thStyle: "width: 18rem",
                },
                {
                    label: "Presidio",
                    key: "denominazionePresidio",
                    sortable: true,
                    thStyle: "width: 18rem",
                },
                {
                    label: "Nome",
                    key: "nome",
                    sortable: true,
                    thStyle: "width: 16rem",
                },
                {
                    label: "Note",
                    key: "note",
                    sortable: true,
                },
                {
                    label: "",
                    class: "sa-table-column-action-double",
                    key: "actions",
                },
            ],
        };
    },
    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
    },
    methods: {
        loadData() {
            let me = this;
            me.$emit("beforeLoadData");
            let sessionStorage = window.sessionStorage;
            //console.log("loadData:", sessionStorage);
            if (sessionStorage["filtroConfigurazionePostiLetto"]) {
                me.filtroConfigurazionePostiLetto = JSON.parse(sessionStorage["filtroConfigurazionePostiLetto"]);
            }
            let filtroPostiLettoPiani = { ...me.filtroConfigurazionePostiLetto, page: me.currentPage, forPage: me.perPage };
            me.$emit("beforLoadData");
            me.loadDataResources(me.pathResource, filtroPostiLettoPiani, me.loadDataSuccess, me.loadDataError);
        },

        loadDataSuccess(response) {
            let me = this;
            me.rows = response.data.data.recordsNumber;
            me.items = response.data.data.list;
            me.listKey++;
            me.$emit("afterLoadData");
        },
        loadDataError(response) {
            let me = this;
            me.$emit("afterLoadData", response);
            me.$bvToast.toast("Errore durante il caricamento dei piani", {
                title: "Errore",
                variante: "danger",
                solid: true,
            });
        },
        onClickDuplicatePiano(item) {
            let me = this;
            me.nuovoPiano = {};
            me.nuovoPiano.nome = null;
            me.nuovoPiano.note = null;
            me.nuovoPiano.codiceStruttura = item.codiceStruttura;
            me.nuovoPiano.denominazionePresidio = item.denominazionePresidio;
            me.nuovoPiano.denominazioneStruttura = item.denominazioneStruttura;
            me.nuovoPiano.id = null;
            me.nuovoPiano.idPianoSorgente = item.id;
            me.nuovoPiano.idPresidio = item.idPresidio;
            me.$refs.mdlDuplicaPiano.show();
        },
        onMdlDuplicaPiano() {
            let me = this;
            this.$bvModal
                .msgBoxConfirm("Si desidera duplicare anche le stanze e i letti?", {
                    title: "Richiesta duplicazione",
                    buttonSize: "sm",
                    okVariant: "secondary",
                    cancelVariant: "danger",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        // console.log("Duplico Tutto");
                        me.nuovoPiano.duplicaStanze = true;
                        me.$refs.mdlDuplicaPiano.hide();
                    } else {
                        // console.log("Duplico Solo il piano");
                        me.nuovoPiano.duplicaStanze = false;
                        me.$refs.mdlDuplicaPiano.hide();
                    }
                    me.duplicaStanze();
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        duplicaStanze() {
            let me = this;
            let link = me.pathResource + "/duplicapiano";
            UtilityMixin.methods.saveResource(link, me.nuovoPiano, me.saveSucessResponse, me.saveErrorResponse);
        },
        saveSucessResponse() {
            let me = this;
            me.loadData();
        },
        saveErrorResponse(response) {
            if (response.response.status === 400) {
                this.$emit("errorRestCall", response);
            } else {
                this.$bvToast.toast("Errore nel salvarei dati del Piano: " + response.message, {
                    title: "",
                    variant: "danger",
                    solid: true,
                });
            }
        },
        onClickVisualizzaPiano(item) {
            let me = this;
            me.$router.replace("/rsaconfigurazionepostilettopiani/view/" + item.id).catch((err) => {
                err;
            });
        },
        onUpdatePiano(id) {
            /* console.log(id);
            me.id = id;
            me.$refs.mdlPianoEdit.show();
            me.$refs.cmpRasConfigurazionePostiLettoPianiEditComponent.init(id); */
            let me = this;
            me.$router.replace("/rsaconfigurazionepostilettopiani/edit/" + id).catch((err) => {
                err;
            });
        },
        onMdlPianoEditSave() {
            let me = this;
            let jsonData = me.$refs.cmpRasConfigurazionePostiLettoPianiEditComponent.getJsonData();
            UtilityMixin.methods.saveResource(me.pathResource, jsonData, me.saveSucessResponse, me.saveErrorResponse);
        },
    },
};
</script>

<style></style>
